import Flash from '../images/character/000.png';
import Char1 from '../images/character/016.png';
import Char2 from '../images/character/017.png';
import Char3 from '../images/character/018.png';
import Char4 from '../images/character/019.png';
import Char5 from '../images/character/020.png';
import Char6 from '../images/character/006.png';
import Char7 from '../images/character/007.png';
import Char8 from '../images/character/008.png';
import Char9 from '../images/character/009.png';
import Char10 from '../images/character/010.png';
import Char11 from '../images/character/011.png';
import Char12 from '../images/character/012.png';
import Char13 from '../images/character/013.png';
import Char14 from '../images/character/014.png';
import Char15 from '../images/character/015.png';

export default function CharacterShowcase(props) {
  let characters = [];
  const images = [Char1, Char2, Char3, Char4, Char5, Char6, Char7, Char8, Char9, Char10, Char11, Char12, Char13, Char14, Char15];
  props.CharacterList.forEach((el, index) => {

    let myClass = '';
    if (props.selectedCharacter.includes(index)) {
      myClass = 'is-selected';
    }

    characters.push(
      <li key={index} className={myClass}>
        <img src={Flash} alt="" className='character-showcase__flash' />
        <img
          src={images.shift()}
          alt={el.name}
          data-name={el.name}
          data-index={index}
          onClick={characterClick}
          className={myClass}
        />
      </li>
    );
  });

  function characterClick(e) {
    if ([...e.target.classList].includes('is-selected')) {
      props.removeCharacter(Number.parseInt(e.target.dataset.index));
    } else {
      props.addCharacter(Number.parseInt(e.target.dataset.index));
      props.updateFewerFlag(false);
    }
  }

  return (
    <>
      <ul className="character-showcase">
        {characters}
      </ul>
    </>
  );
}

